import { getCookie } from "../utils/cookie-handler";

/**
 *
 * @returns {Number}
 */
export function getCartCount() {
    return parseInt(getCookie('_bo_basket_count'), 10) || 0;
}

/**
 *
 * @returns {Boolean}
 */
export function getLoggedIn() {
    return getCookie('_bo_logged_in') == 1;
}

/**
 *
 * @returns {String}
 */
export function getMOS() {
    const mos = getCookie('_bo_mos')
    return mos ? mos : window.AppConfig.defaults.mos;
}

/**
 *
 * @returns {String}
 */
export function getSource() {
    const source = getCookie('_bo_source_no');
    return source ? source : window.AppConfig.defaults.source;
}

/**
 *
 * @returns {String}
 */
export function getUserName() {
    return getCookie('_bo_first_name');
}